export const primary = {
  beige: "#f2ecdf",
  blue: "#0e3354",
  grayblue: "#E6EBF1",
  cornflower: "#719cf1",
  tangerine: "#fb927c",
  white: "#fafafa",
  warning: "#e5ad51",
  green: "#91b04f",
  orange: "#de7747",
  pink: "#e5a0b3",
  brown: "#bd986f",
};

export const gray = {
  black: "#191919",
  darkestgray: "#202020",
  darkergray: "#5d5d5d",
  darkgray: "#969490",
  gray: "#cccac8",
  lightgray: "#e5e3e1",
  lightergray: "#f2f0ed",
  faintgray: "#fffdfa",
  white: "#fafafa",
};

export const black = {
  black: "#000000",
  dark: "#292929",
};
